import { observer } from 'mobx-react';
import { useMemo } from 'react';
import MealItem from '../../components/MealItem/MealItem';
import { getFakeMealItem } from '../../helpers/meals';
import mealsStore from '../../store/mealsStore';
import { IMealChoice, IMealItem } from 'src/types/combo';
import { IProductV4Size } from 'src/types/product';
import { productUtils } from '~/utils/productUtils';

interface IProps {
  choice: IMealChoice;
}

const MealItems: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const items = useMemo((): IMealItem[] => {
    const itemInSize = (product: IProductV4Size): IMealItem => {
      return noSortingItems.find((item) => item.size_id === product.id) || getFakeMealItem(product.id || 0, props.choice.group_id, props.choice.id);
    };

    const noSortingItems: IMealItem[] = mealsStore.meal?.items.filter((item) => item.choice_id === props.choice.id) || [];
    const sortingItems: IMealItem[] =
      mealsStore.meal?.sizes.reduce((sum: IMealItem[], current: IProductV4Size) => sum.concat(itemInSize(current)), []) || [];

    return sortingItems;
  }, [props, mealsStore.meal?.sizes, mealsStore.meal?.groups, mealsStore.meal?.choices, mealsStore.meal?.items]);

  return (
    <ul className="d-flex flex-row">
      {items.map((item, index) => (
        <MealItem key={productUtils.getMealItemKey(item, index)} item={item} />
      ))}
    </ul>
  );
});

export default MealItems;
